<template>
  <el-dialog class="cs-cancel-course-dialog" title="撤销课节" :visible="visible" :close-on-click-modal="false"
    width="480px" append-to-body @close="close">
    <el-alert class="cs-cancel-course-alert" type="warning" :closable="false" show-icon
      title="撤销后该课节不再计入签到与出勤并同时删除已上传视频"></el-alert>
    <el-form ref="form" :model="model" :rules="rules" label-position="top" @submit.native.prevent>
      <el-form-item label="撤销原因" prop="reason">
        <el-input type="textarea" v-model="model.reason" :rows="4" maxlength="500" show-word-limit
          placeholder="请输入撤销原因"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="cs-cancel-course-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="danger" :loading="loading" @click="submit">确认撤销</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        reason: ""
      },
      rules: {
        reason: [
          {
            required: true,
            message: "请输入撤销原因",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.model.reason = "";
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        });
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    submit() {
      const reason = (this.model.reason || "").trim();
      this.model.reason = reason;
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.$emit("submit", reason);
      });
    }
  }
};
</script>

<style lang="scss">
body .cs-cancel-course-dialog .el-dialog {
  .el-dialog__header {
    padding: 18px 24px 8px;
    text-align: left;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #303133;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 20px;
  }

  .el-dialog__body {
    padding: 8px 24px 0;
  }

  .el-dialog__footer {
    padding: 0 24px 20px;
  }

  .cs-cancel-course-alert {
    margin-bottom: 16px;
    padding: 8px 12px;
  }

  .el-form-item {
    margin-bottom: 8px;
  }

  .el-form-item__label {
    padding: 0 0 6px;
    line-height: 22px;
    color: #303133;
  }

  .el-textarea__inner {
    padding-bottom: 22px;
    line-height: 1.5;
  }

  .cs-cancel-course-footer {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/cancelCourseActivationDialog.vue